import React, { useCallback, useContext, useEffect, useState } from "react";
import { getMoengage } from "../../utils/moengage.js";
// import { useHistory, useLocation } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/advance/Loading";
import Modal from "../../components/advance/Modal";
import useMediaQuery from "../../hooks/useMediaQuery";
import EligibilityModal from "../../modals/EligibilityModal";
import ErrorModal from "../../modals/ErrorModal";
import FinbitIframeModal from "../../modals/FinbitIframeModal";
import IncomeMaxRetry from "../../modals/IncomeMaxRetry";
import IncomeVerificationModal from "../../modals/IncomeVerificationModal";
import { UserContext } from "../../shared/context/UserContext";
// import VendorService from '../../../shared/services/VendorService';
import poll from "../../utils/poll";
import sendRequest from "../../utils/sendRequest";
// import Progress from '../progress/Progress';
// import Summary from '../summary/Summary';
// import { AfterLoginLayoutWrapper } from '../_styles/AfterLoginLayoutWrapper';
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import { IncomeVerificationWrapper } from "./_styles/IncomeVerificationWrapper";
// import ProgressBar from "../../components/navigation/progress_bar/ProgressBar";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
// import graphic from "../../assets/svg/EPL_think_svg/IncomeVerifaction.svg";
// import iconIncomeCard from "../../assets/svg/EPL_think_svg/Icon_IncomeCard.svg";
import iconDot from "../../assets/svg/EPL_think_svg/Icon_Dot.svg";
import iconLogin2 from "../../assets/svg/EPL_think_svg/Icon_Login2.svg";
import iconUpload2 from "../../assets/svg/EPL_think_svg/Icon_Upload2.svg";
import FloatingInput from "../../components/base/FloatingInput";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
// import Dropdown from "../../components/core/EPL_Dropdown_think"
import { GetCustomerDetailsContext, validateInputExistenece } from "../../App";
import {
  GET_PERFIOS_LINK,
  GET_TARTAN_LINK,
  TARTAN_POLLING,
  GET_BANK_MASTER,
  AA_LINK,
  MOVE_STAGE_BACK,
  PERFIOS_TRANSACTION_STATUS,
  AA_TRANSACTION_STATUS,
} from "../../Config";
import { PerfiosStatusRetryModal } from "../other-pages/Modals/AllModal";
import EmandateIframeModal from "../../modals/EmandateIframeModal";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { encrypt } from "../../utils/crypto";

import iconUpload from "../../assets/svg/EPL_think_svg/Icon_Upload.svg";
import CustomButton from "../../components/core/CustomButton";
import { isStageLogin } from "../../shared/validations/StageLogin";
import isEnglish, { isEnglishNewCheck } from "../../shared/validations/isEnglish";
import Button from "../../components/core/EPL_Button_Think";
import ScenarioBasedModal from "../other-pages/Modals/ScenarioBasedModal";
import { encryptedData } from "../../utils";

const getInternalStage = (stage, stage_status) => {
  if (stage === "INCOME_CHECK" && stage_status === "INIT") {
    return "INCOME_CHECK_INIT";
  } else if (stage === "INCOME_CHECK" && stage_status === "INCOMPLETE") {
    return "INCOME_CHECK_INCOMPLETE";
  } else if (stage === "INCOME_CHECK" && stage_status === "COMPLETE") {
    return "INCOME_CHECK_COMPLETE";
  } else {
    return "INCOME_CHECK_INIT";
  }
};

const IncomeVerification = () => {
  const moengage = getMoengage();
  // const history = useHistory();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  const [file, setFile] = React.useState("");
  const [base64String, setBase64String] = useState("");
  const [zipContent, setZipContent] = useState();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // const [isBankStatement, setIsBankStatement] = useState(false);
  const [isBankStatement, setIsBankStatement] = useState(true);
  const [bankName, setBankName] = useState("");
  const [selectedBankNamePerfiosId, setSelectedBankNamePerfiosId] =
  useState("");
  const [bankNameError, setBankNameError] = useState(false);
  const [bankNameOptions, setBankNameOptions] = useState();
  const [bankStatementOptions, setBankStatementOptions] = useState();
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  //   );
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [statementOptionBank, setStatementOptionBank] = useState([]);
  const [netBankingOptionBank, setNetBankingOptionBank] = useState([]);
  const [AAOptionBank, setAAOptionBank] = useState([]);
  const [choosedStatementOption, setChoosedStatementOption] = useState(false);
  const [showShimmer, setShowShimmer] = useState(true);
  const [perfiosStatusCheck, setPerfiosStatusCheck] = useState(false);
  const [skipIncomeModal, setSkipIncomeModal] = useState(false);

  let applicationFormNumber;

  useEffect(() => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("IncomeVerification customerDetails: ", customerDetails);
      setShowShimmer(false);
      applicationFormNumber = customerDetails?.application_form_number;
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      if (customerDetails?.Data?.isError === "True") {
        // setShowShimmer(true);
        console.log(">>>><<<<<<<<<<");
        if (parseInt(customerDetails?.Data?.retry_count) > 0) {
          if (customerDetails?.Data?.api_name === "perfios_institution_match") {
            getBankList("A");
          }
        } else {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      } else {
        navigate(`${route}`, {
          replace: true,
          state: {
            customerDetails: customerDetails,
          },
        });
      }
    } else {
      // console.log("IncomeVerification Ouch customerDetails ");
    }
  }, [customerDetails]);

  const { user, setUser } = useContext(UserContext);
  const [openEmandateIframe, setOpenEmandateIframe] = useState(false);

  const [emandate, setEmandate] = useState({
    // process_id: user.mandate_id,
    url: user.epl_emandate_url,
    showIframeCloseButton: true,
  });

  useEffect(() => {

    isStageLogin(    
    customerDetails?.Data?.uuid,
    customerDetails?.Data?.mobile,
    customerDetails?.source,
    );

    checkPerfiosStatus();
    checkAAStatus();
  }, []);

  useEffect(() => {
    if (bankName !== "") {
      const timeOutId = setTimeout(() => getBankList(bankName), 1000);
      return () => clearTimeout(timeOutId);
    } else {
      getBankList("A");
    }
  }, [bankName]);

  var bankOptions = [
    {
      title: "Account Aggregator",
      icon: iconDot,
      subTitle: "Using OTP based consent through your registered mobile number",
      applicable: true,
      key: "AA",
    },
    {
      title: "Upload Bank statement",
      icon: iconUpload2,
      subTitle:
        "Share PDF statements of your active salary account from last 6 months till date",
      applicable: true,
      key: "STATEMENT",
    },
    {
      title: "Login to NetBanking",
      icon: iconLogin2,
      subTitle: "Using internet banking credentials of active salary account",
      applicable: true,
      key: "NETBANKING_FETCH",
    },
  ];

  const [description, setDescription] = useState("");
  const [finbitURL, setFinbitURL] = useState("");
  const [bankLists, setBankLists] = useState([]);

  const [modal, setModal] = useState("");

  const checkCKYCStatus = useCallback(async () => {
    // console.log("Loading CKYC");
    setModal("LOADING_CKYC");
    setModal("");
    // console.log("Loaded CKYC");
  }, [navigate, applicationFormNumber]);

  const checkEligibilityStatus = useCallback(async () => {
    try {
      // console.log("Setting INCOME_CHECK_COMPLETE");
      setModal("");
      // console.log("... INCOME_CHECK_COMPLETE");
    } catch (error) {
      setModal("TECHNICAL_ERROR");
      console.error(`Unknown Error: ${error}`);
    }
  }, [applicationFormNumber]);

  const checkIncomeStatus = useCallback(async () => {
    try {
      // console.log("Checking checkEligibilityStatus");
      setModal("ELIGIBILITY");
      await checkEligibilityStatus();
      // console.log("Checked checkEligibilityStatus");
    } catch (error) {
      setModal("TECHNICAL_ERROR");
      console.error(`Unknown Error: ${error}`);
    }
  }, [applicationFormNumber, checkEligibilityStatus, navigate]);

  const incomeCheck = useCallback(async () => {
    // console.log("Doing incomeCheck");
    setModal("LOADING");
    try {
      var IFrameUrl = "https://rzp.io/i/YK8yrpE";
      // console.log("Loading FINBIT_IFRAME");
      setFinbitURL(IFrameUrl);
      setModal("FINBIT_IFRAME");
      // console.log("Loaded FINBIT_IFRAME");
      // console.log("...INCOME_CHECK_INCOMPLETE");
    } catch (error) {
      setModal("TECHNICAL_ERROR");
      console.error(`Unknown Error: ${error}`);
    }
  }, [applicationFormNumber]);

  const uploadBankStatement = () => {
    setIsBankStatement(!isBankStatement);
  };

  // useEffect(() => {
  //   if (isBankStatement) {
  //     setBankNameOptions(createBankNameOptions());
  //   } else {
  //     setBankName("");
  //     setBankStatementOptions([]);
  //   }
  // }, [isBankStatement]);

  useEffect(() => {
    // console.log(statementOptionBank);
    // console.log(netBankingOptionBank);
    // console.log(bankLists);
    if (isBankStatement && bankLists.includes(bankName)) {
      setBankStatementOptions(
        createBankStatementOptions(
          statementOptionBank,
          netBankingOptionBank,
          AAOptionBank
        )
      );
    } else {
      setBankStatementOptions([]);
    }
  }, [bankName,bankLists]);

  // const bankLists = ["HDFC Bank", "Kotak Mahindra Bank", "State Bank of India"];

  const createBankNameOptions = (
    dropDownLabel = bankNameOptions,
    isFilter = false,
    filterText = ""
  ) => {
    let options = [];
    let allBankNames = [];
    let statementBanks = [];
    let netBankingBanks = [];
    let aaBanks = [];
    let uniqueList = new Set();

    if (dropDownLabel.dropDownLabel) {
      for (let i = 0; i < dropDownLabel.dropDownLabel.length; i++) {
        if (dropDownLabel.dropDownLabel[i].name === "No Bank Found") {
          options.push({
            label: dropDownLabel.dropDownLabel[i].name,
            value: dropDownLabel.dropDownLabel[i].name,
            func: () => {
              setBankName("");
              showDropdown();
            },
          });
          return options;
        }
        allBankNames.push(dropDownLabel.dropDownLabel[i].name);
        if (
          dropDownLabel.dropDownLabel[i].processing_type
            .split(",")
            .includes("STATEMENT")
        ) {
          statementBanks.push(dropDownLabel.dropDownLabel[i].name);
        }
        if (
          dropDownLabel.dropDownLabel[i].processing_type
            .split(",")
            .includes("NETBANKING_FETCH")
        ) {
          netBankingBanks.push(dropDownLabel.dropDownLabel[i].name);
        }
        if (
          dropDownLabel.dropDownLabel[i].processing_type
            .split(",")
            .includes("AA")
        ) {
          aaBanks.push(dropDownLabel.dropDownLabel[i].name);
        }
        if (
          isFilter &&
          dropDownLabel.dropDownLabel[i]
            ?.toLowerCase()
            .indexOf(filterText.toLowerCase()) > -1
        ) {
          if (!uniqueList.has(dropDownLabel.dropDownLabel[i].name)) {
            uniqueList.add(dropDownLabel.dropDownLabel[i].name);
            options.push({
              label: dropDownLabel.dropDownLabel[i].name,
              value: dropDownLabel.dropDownLabel[i].name,
              func: () => {
                setSelectedBankNamePerfiosId(
                  dropDownLabel.dropDownLabel[i].perfios_id
                );
                setBankName(dropDownLabel.dropDownLabel[i].name);
                setBankNameError(false);
                showDropdown();
              },
            });
          }
        } else if (!isFilter) {
          if (!uniqueList.has(dropDownLabel.dropDownLabel[i].name)) {
            uniqueList.add(dropDownLabel.dropDownLabel[i].name);
            options.push({
              label: dropDownLabel.dropDownLabel[i].name,
              value: dropDownLabel.dropDownLabel[i].name,
              func: () => {
                if (dropDownLabel.dropDownLabel[i].name !== "No Bank Found") {
                  setSelectedBankNamePerfiosId(
                    dropDownLabel.dropDownLabel[i].perfios_id
                  );
                  setBankName(dropDownLabel.dropDownLabel[i].name);
                  setBankNameError(false);
                } else {
                  setBankName("");
                }
                showDropdown();
              },
            });
          }
        }
      }
    }
    setStatementOptionBank(statementBanks);
    setNetBankingOptionBank(netBankingBanks);
    setAAOptionBank(aaBanks);
    setBankLists(allBankNames);
    return options;
  };

  const showDropdown = () => {
    document.getElementById("myDropdown").classList.toggle("show");
  };
  const createBankStatementOptions = (
    statementOptionBank,
    netBankingOptionBank,
    AAOptionBank
  ) => {
    var options = [];
    for (let i = 0; i < bankOptions.length; ++i) {
      // console.log(customerDetails);
      if (
        (bankOptions[i]["key"] === "STATEMENT" &&
          statementOptionBank.includes(bankName)) ||
        (bankOptions[i]["key"] === "NETBANKING_FETCH" &&
          netBankingOptionBank.includes(bankName)) ||
        (bankOptions[i]["key"] === "AA" && AAOptionBank.includes(bankName))
      ) {
        var element = (
          <>
            {showShimmer ? (
              <>
                <ShimmerPlaceholder visible={showShimmer} height="5em" />
              </>
            ) : (
              <>
                <div
                  className="bankOptions"
                  onClick={() => {
                    // history.replace({
                    //   // pathname: `/selfie`,
                    //   pathname: `/loan-ipo`,
                    //   search: location.search,
                    // });
                    // setChoosedStatementOption(bankOptions[i]["key"]);
                    // console.log("bankOptions[i][key]", bankOptions[i]["key"]);
                    perfiosGenerateUrl(bankOptions[i]["key"]);
                  }}
                >
                  <div className="line-one">
                    <Title
                      id="pageTitle"
                      className="pageTitle"
                      text={bankOptions[i]["title"]}
                      visible={true}
                      clickable={false}
                      style={{
                        fontSize: "16px",
                        justifyContent: "spaceBetween",
                      }}
                    />
                    <div className="icon">
                      <img
                        className="bankStatementIcons"
                        src={bankOptions[i]["icon"]}
                        alt="BankStatementOptions.svg"
                        width="25"
                        height="25"
                      />
                    </div>
                  </div>
                  <div className="line-two">
                    <SubTitle
                      id="pageSubTitle"
                      className="pageSubTitle"
                      text={bankOptions[i]["subTitle"]}
                      visible={true}
                      clickable={false}
                      style={{
                        padding: "0px",
                      }}
                    />
                  </div>
                </div>
              </>
            )}
          </>
        );
        // console.log("\tElement: ", bankOptions[i]);
        options.push(element);
      }
    }
    // console.log("Bank Statement Options Created: ", options.length);
    return options;
  };

  // const bankNameDropdownChange = (selectedOption) => {
  //   setBankName(selectedOption["value"]);
  // };

  const bankNameDropdown = (filterText) => {
    if (!isEnglishNewCheck(filterText)) {
			setBankNameError(true);
			setBankName("");
		} else {
			setBankName(filterText);
			setBankNameOptions(createBankNameOptions(true, filterText));
			setBankNameError(false);
		}
  };

  // const handleOnSubmit = async () => {
  //   // setModal("LOADING");
  //   try {
  //     // // console.log("callInsertSelfieAPI: inside try block")
  //     const formData = new FormData();
  //     const requestData = {
  //       application_form_no: customerDetails.application_form_number,
  //     };
  //     formData.append("data", encryptedData(requestData));
  //     // console.log(requestData);
  //     const response = await sendRequest(
  //       "/" + customerDetails.source + GET_TARTAN_LINK,
  //       formData
  //     );

  //     // console.log("callTartanURL: response => ", response);

  //     if (response.response.Success === true) {
  //       setUser({
  //         ...user,
  //         epl_emandate_url: response.response.link,
  //       });
  //       setEmandate({
  //         ...emandate,
  //         url: response.response.link,
  //       });
  //       setOpenEmandateIframe(true);
  //       setTartanRequestId(response.response["z-request_id"]);
  //       await tartanPolling(response.response["z-request_id"]);
  //       // window.open(response.response.link, "_blank", "height=600,width=400");
  //       // console.log(response.response.link);
  //     }
  //   } catch (error) {
  //     // console.log(error);
  //     var route = getRouteFromLoanStageService({
  //       source: customerDetails.source,
  //       stage: "error",
  //     });
  //     // console.log("route: ", route);
  //     navigate(`${route}`, {
  //       replace: true,
  //     });
  //     // console.log("callTartanURL: inside catch block");
  //   }
  // };

  const checkPerfiosStatus = async () => {
    try {
      const formData = new FormData();
      const requestData = {
      };
      formData.append("data", encryptedData(requestData));
      // setShowShimmer(true);
      const response = await sendRequest(
        "/" + customerDetails.source + PERFIOS_TRANSACTION_STATUS,
        {
        }
      );
      // setShowShimmer(false);
      if (response.new_link === false) {
        var route = "/" + customerDetails.source + "/loading";
        navigate(`${route}`, {
          replace: true,
        });
      }
      if (
        // response.response.status.status === "IN_PROGRESS" ||
        response.response.status.status === "COMPLETED" ||
        response.response.status === "DS_COMPLETED"
      ) {
        // console.log(">>>>>>>>>>>");
        var route = "/" + customerDetails.source + "/loading";
        navigate(`${route}`, {
          replace: true,
        });
      }
      if (
        response.response.status.status === "IN_PROGRESS" ||
        response.response.status.status === "INITIATED" ||
        response.response.status.status === "START"
      ) {
        moengage?.track_event("Income verification", {
          Income_verification_status: false,
          "journey name": customerDetails.source,
        });
        // show modal and close
        setPerfiosStatusCheck(true);
      }
      setShowShimmer(false);
    } catch (error) {
      console.log(error);
      // var route = getRouteFromLoanStageService({
      //   source: source,
      //   stage: "error",
      // });
      // // console.log("route: ", route);
      // navigate(`${route}`, {
      //   replace: true,
      // });
      // console.log("Error: ", error);
    }
  };

  const checkAAStatus = async () => {
    try {
      const formData = new FormData();
      const requestData = {
      };
      formData.append("data", encryptedData(requestData));
      // setShowShimmer(true);
      const response = await sendRequest(
        "/" + customerDetails.source + AA_TRANSACTION_STATUS,
        {
        }
      );
      // setShowShimmer(false);
      console.log(response.response);
      if (
        // response.response.status.status === "IN_PROGRESS" ||
        response.response.status.status === "COMPLETED" ||
        response.response.status === "DS_COMPLETED"
      ) {
        // console.log(">>>>>>>>>>>");
        var route = "/" + customerDetails.source + "/loading?type=AA";
        navigate(`${route}`, {
          replace: true,
        });
      }
      if (
        response.response.status.status === "IN_PROGRESS" ||
        response.response.status.status === "INITIATED" ||
        response.response.status.status === "START"
      ) {
        // show modal and close
        setPerfiosStatusCheck(true);
      }
      setShowShimmer(false);
    } catch (error) {
      console.log(error);
      // var route = getRouteFromLoanStageService({
      //   source: source,
      //   stage: "error",
      // });
      // // console.log("route: ", route);
      // navigate(`${route}`, {
      //   replace: true,
      // });
      // console.log("Error: ", error);
    }
  };
  const [institutionResponse, setInstitutionResponse] = useState();

  const getBankList = async (bankName) => {
    try {
      const formData = new FormData();
      const payload = {
        institution_name: bankName,
      };
      formData.append("data", encryptedData(payload));
      // setShowShimmer(true);
      try {
        const response = await sendRequest(
          "/" + customerDetails.source + GET_BANK_MASTER,
          formData
        );
        // setShowShimmer(false);
        if (response.response.Success) {
          if (response.response.data.length === 0) {
            setBankNameOptions([{ name: "No Bank Found" }]);
            setBankNameOptions(
              createBankNameOptions({
                dropDownLabel: [{ name: "No Bank Found" }],
              })
            );
          } else {
            setBankNameOptions(response.response.data);
            setBankNameOptions(
              createBankNameOptions({
                dropDownLabel: response.response.data,
              })
            );
            setInstitutionResponse(response.response.data);
          }
        }
      } catch (error) {
        if (customerDetails.source === "upsell") {
          // updateLead(
          //   customerDetails.source,
          //   64,
          //   customerDetails.application_form_number
          // );
        }
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        // updateLead(
        //   customerDetails.source,
        //   64,
        //   customerDetails.application_form_number
        // );
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  const tartanPolling = async (tartanRequestId) => {
    try {
      // console.log("Approved/Rejected");
      const { response } = await poll(
        async () =>
          await sendRequest("/" + customerDetails.source + TARTAN_POLLING, {
            z_request_id: tartanRequestId,
          }),
        ({ response }) => response.Approved || response.Failed
      );
      if (response.Success) {
        /* Successful Response Action */
        setOpenEmandateIframe(false);
      } else {
        /* Failed Response Action */
        // setInternalPage('MAIN');
        // setModal('');
      }
    } catch (error) {
      // console.log(error);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      /* Handle unexpected response */
      // if (error.code === 'ECONNABORTED') {
      //     setInternalPage('REQUEST_TIMEOUT');
      // } else {
      //     /* CRM Stage - E-Mandate Check Technical Failure */
      //     // updateLeadApi({ crmId: 47 });
      //     setCrmId(47)
      //     setInternalPage('TECHNICAL_ERROR');
      //     // setInternalPage('TECHNICAL_ERROR');
      //     console.error(`Unknown Error: ${error}`);
      // }
    }
  };

  // console.log(customerDetails.stage);

  const perfiosGenerateUrl = async (statementOption) => {
    setBankStatementOptions([]);
    // setModal("LOADING");
    if (statementOption === "AA") {
      try {
        // console.log("callInsertSelfieAPI: inside try block")
        const formData = new FormData();
        // console.log("statementOption: ", statementOption);
        const requestData = {
          returnURL: `https://oneapp.abfldirect.com/${customerDetails.source}/loading?type=AA`,
          fipIds: selectedBankNamePerfiosId,
        };
        formData.append("data", encryptedData(requestData));
        const response = await sendRequest(
          "/" + customerDetails.source + AA_LINK,
          formData
        );

        // console.log("callPerfiosURL: response => ", response);

        // setCustomerDetails({
        //   ...customerDetails,
        //   stage: response.response.STAGE,
        // });
        // return;
        // TODO: Handle Perfios

        if (response.response.Success === true) {
          console.log(response.response);
          setUser({
            ...user,
            epl_emandate_url: response.response.redirectURL,
          });
          setEmandate({
            ...emandate,
            url: response.response.redirectURL,
          });
          // setOpenEmandateIframe(true);
          window.open(response.response.redirectURL, "_self");
          // console.log(response.response.link.url);
          // /epl/perfios_transaction_status

          // const { res } = await poll(
          //   async () =>
          //     await sendRequest("/epl/perfios_transaction_status", {
          //       application_form_no: applicationFormNumber,
          //     }),
          //   ({ response }) => response.status.reportAvailable === "true",
          //   30000
          // );

          // perfiosWindow.close();
        }
      } catch (error) {
        // console.log(error);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
        // console.log("Error: ", error);
      }
    } else {
      try {
        // console.log("callInsertSelfieAPI: inside try block")
        const formData = new FormData();
        // console.log("statementOption: ", statementOption);
        const requestData = {
          processing_type: statementOption,
          return_url: `https://oneapp.abfldirect.com/${customerDetails.source}/loading`,
          // return_url: `http://localhost:3000/${customerDetails.source}/loading`,
          data_source: null,
          current_stage: customerDetails.stage,
          stage_conditions: {
            tartan: false,
          },
        };
        formData.append("data", encryptedData(requestData));
        const response = await sendRequest(
          "/" + customerDetails.source + GET_PERFIOS_LINK,
          formData
        );

        // console.log("callPerfiosURL: response => ", response);

        // setCustomerDetails({
        //   ...customerDetails,
        //   stage: response.response.STAGE,
        // });
        // return;
        // TODO: Handle Perfios

        if (response.response.Success === true) {
          setUser({
            ...user,
            epl_emandate_url: response.response.link.url,
          });
          setEmandate({
            ...emandate,
            url: response.response.link.url,
          });
          // setOpenEmandateIframe(true);
          window.open(response.response.link.url, "_self");
          // console.log(response.response.link.url);
          // /epl/perfios_transaction_status

          // const { res } = await poll(
          //   async () =>
          //     await sendRequest("/epl/perfios_transaction_status", {
          //       application_form_no: applicationFormNumber,
          //     }),
          //   ({ response }) => response.status.reportAvailable === "true",
          //   30000
          // );

          // perfiosWindow.close();
        }
      } catch (error) {
        // console.log(error);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
        // console.log("Error: ", error);
      }
    }
  };

  // useEffect(() => {
  //   if (internalStage === "INCOME_CHECK_INCOMPLETE") {
  //     checkIncomeStatus();
  //   } else if (internalStage === "INCOME_CHECK_COMPLETE") {
  //     checkCKYCStatus();
  //   }
  // }, [checkCKYCStatus, checkIncomeStatus, internalStage]);

  const handleOnCloseEmandateIframeModal = () => {
    navigate(`/loan-ipo`, {
      replace: true,
      state: {
        customerDetails: customerDetails,
        // application_form_number: customerDetails.application_form_number
      },
    });
  };

  const handleUpload = async (event) => {
    // console.log("In handleUpload");
    // var input = document.createElement('input');
    // input.type = 'file';
    // input.onchange = async (e) => {
    //   // console.log("In handleUpload ...onchange: ", e);
    //   // getting a hold of the file reference
    //   var file = e.target.files[0];
    //   // console.log("In handleUpload ...onchange: ", file);
    //   // setting up the reader
    //   var reader = new FileReader();
    //   // console.log("next");
    //   // console.log(file);
    //   var upld = file.name.split('.').pop();
    //   if(upld=='pdf'){
    //     alert("File uploaded is pdf")
    //     // reader.readAsDataURL(file); // this is reading as data url
    //     // // here we tell the reader what to do when it's done reading...
    //     // reader.onload = readerEvent => {
    //     //   var content = readerEvent.target.result; // this is the content!
    //     //   document.querySelector('#content').style.backgroundImage = 'url('+ content +')';
    //     // }
    //     reader.onload = function () {
    //       setBase64String(reader.result.replace("data:", "").replace(/^.+,/, ""));
    //     }
    //     reader.readAsDataURL(file);
    //     var zip = new JSZip();
    //     zip.file('file.pdf', file.split('base64,')[1], {
    //       base64: true
    //     });
    //     const content = await zip.generateAsync({ type: 'blob' });
    //     // // console.log(await zip.generateAsync({ type: 'blob' }))
    //     setZipContent(content);
    //   }else{
    //     alert("Only PDF are allowed")
    //   }
    // }
    // input.click();
  };

  const moveStageBack = async () => {
    try {
      const response = await sendRequest(
        "/" + customerDetails.source + MOVE_STAGE_BACK, {}
      );
      if (response.response.Success) {
        setCustomerDetails({
          ...customerDetails,
          stage: response?.response?.STAGE,
        });
      }
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(route, {
          replace: true,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    }
  };

  return (
    <>
      <ProgressBar showProgress={true} currentStep={2} showText={false} />
      <PerfiosStatusRetryModal
        isOpen={perfiosStatusCheck}
        onClose={() => {
          setPerfiosStatusCheck(false);
        }}
      />
      <ScenarioBasedModal
        id="bd-modal"
        isOpen={skipIncomeModal}
        onClose={() => { }}
        modalMessage="Are you sure you want to skip the income verification ?"
        modalSubmitMessage="Ok"
        onModalSubmit={moveStageBack}
        secondButton={true}
        modalSubmitMessagebutton2="Cancel"
        onModalSubmitbutton2={() => {
          setSkipIncomeModal(false)
        }}
      />
      <AfterLoginLayoutWrapper>
        <Loading
          open={modal === "LOADING_CKYC"}
          msg="Please wait while we verify your details."
        />
        <Loading open={modal === "LOADING"} />
        <Modal
          open={openEmandateIframe}
          showCloseButton={emandate.showIframeCloseButton}
          closeOnClickOutside={true}
          onClose={() => handleOnCloseEmandateIframeModal()}
          id="bdp-emandate-iframe-parent"
        >
          <EmandateIframeModal url={emandate.url} id="bdp-emandate-iframe" />
        </Modal>
        <Modal open={modal === "TECHNICAL_ERROR"} onClose={() => setModal("")}>
          <ErrorModal />
        </Modal>
        <Modal
          open={modal === "FINBIT_IFRAME"}
          showCloseButton={false}
          closeOnClickOutside={false}
          id="bs-finbit_iframe-parent"
        >
          <FinbitIframeModal url={finbitURL} id="bs-finbit_iframe" />
        </Modal>
        <Modal open={modal === "INCOME_MAX_RETRY"}>
          <IncomeMaxRetry url={description} />
        </Modal>
        <Modal
          open={modal === "INCOME_VERIFICATION_FAILED"}
          closeOnClickOutside={false}
          showCloseButton={false}
        >
          <IncomeVerificationModal
            onClick={() => {
              // setInternalStage("INCOME_CHECK_INIT");
              incomeCheck();
            }}
            url={description}
          />
        </Modal>
        <Modal
          open={modal === "ELIGIBILITY"}
          closeOnClickOutside={false}
          showCloseButton={false}
        >
          <EligibilityModal />
        </Modal>
        <IncomeVerificationWrapper className="first-child">
          <div className="mainContent">
            {/* {!isBankStatement ? (
              <>
                <SubTitle
                  id="pageSubTitle"
                  className="pageSubTitle"
                  text={`Login with your organisational HR credentials to get the 3 months salary slips`}
                  visible={true}
                  clickable={false}
                  style={{
                    padding: "0px",
                  }}
                />
                <CustomButton
                  id="Btn"
                  className="Btn"
                  disabled={false}
                  mobile={isMobile}
                  onClick={handleOnSubmit}
                  icon={
                    <>
                      <img
                        src={iconLogin}
                        alt="LoginIcon.svg"
                        height="25"
                        width="25"
                      />
                    </>
                  }
                  text={"Organisational HR Portal"}
                  style={{
                    flexDirection: "row",
                    fontSize: isMobile ? "1.6rem" : "",
                    backgroundColor: "#AE8E68",
                    border: "0px solid #AE8E68",
                    boxShadow: "none",
                    width: "90%",
                    borderRadius: "10px",
                  }}
                />
                <SubTitle
                  id="pageSubTitle"
                  className="pageSubTitle"
                  text={`OR`}
                  visible={true}
                  clickable={false}
                  style={{
                    padding: "5px",
                    fontSize: "16px",
                  }}
                />
              </>
            ) : (
              <></>
            )} */}
            {/* <SubTitle
              id="pageSubTitle"
              className="pageSubTitle"
              text={`Provide 6 Months Salary Account Bank Statement`}
              visible={true}
              clickable={false}
              style={{
                padding: "0px",
              }}
            />
            <CustomButton
              id="Btn"
              className="Btn"
              disabled={false}
              mobile={isMobile}
              onClick={uploadBankStatement}
              icon={
                <>
                  <img
                    src={iconUpload}
                    alt="UploadIcon.svg"
                    height="25"
                    width="25"
                  />
                </>
              }
              text={"Bank Statement"}
              style={{
                flexDirection: "row",
                fontSize: isMobile ? "1.6rem" : "",
                backgroundColor: isBankStatement ? "#C4A167" : "#AE8E68",
                border: "0px solid #AE8E68",
                boxShadow: "none",
                width: isBankStatement ? "70%" : "90%",
                borderRadius: "10px",
              }}
            /> */}
            {isBankStatement ? (
              <>
                <ShimmerPlaceholder visible={showShimmer} />
                <FloatingInput
                  visible={!showShimmer}
                  on_change={(e) => {
                    bankNameDropdown(e.target.value);
                  }}
                  value={bankName}
                  type={"text"}
                  label="Bank Name"
                  error={bankNameError}
									error_message={"Please enter valid name"}
                  options={bankNameOptions}
                />
              </>
            ) : (
              <></>
            )}
            {
              bankName !== "" ? customerDetails?.Data?.employment_type === "self_employed" ? (
                <p className="income-page-note">Note: Please make sure that you are selecting the current account of your sole proprietary business</p>
              ) : (
                <p className="income-page-note">Note: Please make sure that you are selecting your salary account</p>
              ) : null
            }
            {bankStatementOptions}
          </div>
          {/* <div className="center">
            <img
              src={graphic}
              alt="IncomeVerification.svg"
              width="200"
              height="200"
            />
          </div> */}
          <div className="bottomDiv no-btn">
            <SubTitle
              id="pageSubTitle"
              className="pageSubTitle"
              text={`By selecting the given options, you will be authorizing Aditya Birla Capital Limited to re-direct you to our partner website. The data provided will be used only to generate a personalized loan offer for you.`}
              visible={true}
              clickable={false}
              style={{
                padding: "0px",
                textAlign: "justify",
              }}
            />
          </div>
        </IncomeVerificationWrapper>
        {/* <div className="summary-container">
          <Summary stage="BANK_STATEMENT" />
        </div> */}
        {
          (customerDetails?.stage === "INCOME_START" || customerDetails?.stage === "PERFIOS_START") &&
          customerDetails?.Data?.requiredHigherLoanAmount === "True" &&
          (customerDetails?.Data?.max_topup !== "None" && customerDetails?.Data?.max_topup !== "0") && (
            <Button
              id="ProceedBtn"
              className="Btn ProceedBtn"
              mobile={isMobile}
              onClick={() => {
                setSkipIncomeModal(true)
              }}
              text={"Skip"}
            />
          )
        }
      </AfterLoginLayoutWrapper>
    </>
  );
};

export default IncomeVerification;
